import { supabase } from './supabase';

export interface ChapterBeat {
  id: number;
  chapter_id: number;
  tenant_id: string;
  title: string;
  description?: string;
  display_order: number;
  is_completed: boolean;
  created_at: string;
  updated_at: string;
}

export const getChapterBeats = async (chapterId: number): Promise<ChapterBeat[]> => {
  const { data, error } = await supabase
    .from('chapter_beats')
    .select('*')
    .eq('chapter_id', chapterId)
    .order('display_order', { ascending: true });

  if (error) {
    console.error('Error fetching chapter beats:', error);
    throw error;
  }

  return data || [];
};

export const createChapterBeat = async (chapterId: number, title: string, description?: string): Promise<ChapterBeat> => {
  // Get current max display_order
  const { data: existing } = await supabase
    .from('chapter_beats')
    .select('display_order')
    .eq('chapter_id', chapterId)
    .order('display_order', { ascending: false })
    .limit(1);
    
  let nextOrder = 0;
  if (existing && existing.length > 0) {
    nextOrder = (existing[0].display_order || 0) + 1;
  }

  const { data, error } = await supabase
    .from('chapter_beats')
    .insert([{
      chapter_id: chapterId,
      title,
      description,
      display_order: nextOrder
    }])
    .select()
    .single();

  if (error) {
    console.error('Error creating chapter beat:', error);
    throw error;
  }

  return data;
};

export const updateChapterBeat = async (beatId: number, updates: Partial<ChapterBeat>): Promise<ChapterBeat> => {
  const { data, error } = await supabase
    .from('chapter_beats')
    .update(updates)
    .eq('id', beatId)
    .select()
    .single();

  if (error) {
    console.error('Error updating chapter beat:', error);
    throw error;
  }

  return data;
};

export const deleteChapterBeat = async (beatId: number): Promise<void> => {
  const { error } = await supabase
    .from('chapter_beats')
    .delete()
    .eq('id', beatId);

  if (error) {
    console.error('Error deleting chapter beat:', error);
    throw error;
  }
};

export const updateChapterBeatsOrder = async (beats: { id: number; display_order: number }[]): Promise<void> => {
  // Supabase doesn't have a simple bulk update via JS client without RPC,
  // so we update sequentially for now
  for (const beat of beats) {
    const { error } = await supabase
      .from('chapter_beats')
      .update({ display_order: beat.display_order })
      .eq('id', beat.id);
      
    if (error) {
      console.error('Error updating beat order:', error);
      throw error;
    }
  }
};
